import * as React from "react";
import { useAppService } from "../../services/AppServiceProvider";
import { useAppState } from "../../store/AppProvider";
import { useEffect } from "react";
import { useLaunchDarkly } from "@bimone/bimtrack-core";

export interface FeatureFlagProviderProps {
    children: React.ReactNode;
}

function FeatureFlagContainer(props: Readonly<FeatureFlagProviderProps>) {
    const {
        services: { subscriptionApiService, officeWrapper, logger },
    } = useAppService();
    const {
        appState: { selectedHub },
        actions: { setSupportedAddinItems },
    } = useAppState();
    const { isInitialized } = useLaunchDarkly();
    const isSupportedDevice = (): boolean => {
        // check if user device has at least DialogApi 1.1 to use the emails viewer
        // https://learn.microsoft.com/en-us/javascript/api/requirement-sets/common/dialog-api-requirement-sets?view=common-js-preview
        if (!Office.context.requirements.isSetSupported("DialogApi", "1.1")) {
            return false;
        }

        return !officeWrapper.isMobileDevice();
    };

    useEffect(() => {
        if (!selectedHub || !isInitialized) {
            return;
        }

        const getSupportedAddinItems = async () => {
            try {
                const newSupportedAddinItems = await subscriptionApiService.getSupportedAddinItems(selectedHub);

                if (!isSupportedDevice()) {
                    newSupportedAddinItems.canUseProjectEmailsViewer = false;
                }

                setSupportedAddinItems(newSupportedAddinItems);
            } catch (error) {
                logger.error(`${error}`);
            }
        };

        getSupportedAddinItems();
    }, [selectedHub, isInitialized]);

    return <React.Fragment>{props.children}</React.Fragment>;
}

export default FeatureFlagContainer;
